import styled from "styled-components";

export const ContentWrap = styled.div`
  margin: 0 auto;
`;
